import { combineReducers } from 'redux';
import { AppReducer } from './AppReducer';
import { Login } from './Login';
import cookiesReducer from './cookiesReducer'
import { tenant } from '../../screens/tenants/redux/tenant.reducer';
import { maintenance } from './maintenance.reducer';

export default combineReducers({
  Login,
  AppReducer,
  cookiesReducer,
  tenant,
  maintenance
});
